module.exports = __webpack_public_path__ + "static/img/c5.82343ea7.png";